<template>
<div>
  <div
    class="price"
    :class="{
      'discount-price': headQDiscountedPrice !== 0
    }"
    >
    {{previewPrice}} kr
  </div>

  <span v-if="headQDiscountedPrice !== 0">
    <b>{{__('Regular price: ')}} <span style="text-decoration: line-through;">2 975 kr</span></b>
    <br>
  </span>
  <i class="shipping">{{__('Free traceable freight in Sweden')}}</i>
</div>
</template>
<script>
export default {
  computed: {
    headQPrice () {
      return this.$store.getters.headQPrice
    },
    headQDiscountedPrice () {
      return this.$store.getters.headQDiscountedPrice
    },
    previewPrice () {
      return this.headQDiscountedPrice || this.headQPrice
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .price {
    font-weight: 700;
    font-size: 36px;
  }

  .shipping {
    font-size: 12px;
  }

  .discount-price {
    color: @color-brand;
  }
</style>
